import { observable, computed, extendObservable, action } from 'mobx';

export default class SaleEditStore {
  @observable page = 1;
  @observable offerData = {};
  @observable docs = [];

  user = null;

  constructor(user) {
    this.user = user;
  }

  @computed get isPage1Valid() {
    const data = this.offerData;

    return !!data.object_type && !!data.object_address;
  }

  @computed get isPage2Valid() {
    return true;
  }

  @computed get isPage3Valid() {
    return true;
  }

  @action initialize(offerData, docs) {
    this.offerData = Object.assign({}, offerData);
    this.docs = (docs || []).slice();
    extendObservable(this.offerData, {
      // Page1
      object_type: offerData.object_type || '',
      object_address: offerData.object_address || '',
      additional_description: offerData.additional_description || '',
      seller_commission_percentage: offerData.seller_commission_percentage || 0,
      owner_financing_offered: offerData.owner_financing_offered || false,
      owner_financing_information: offerData.owner_financing_information || '',
    });
  }
}

export { SaleEditStore };



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_pr/stores/index.js